import React from 'react';
import { asyncComponent } from '@jaredpalmer/after';
import { ERROR_404_ROUTE } from './config/constants';


const routes = [
  {
    exact: true,
    isPublic: true,
    path: '/',
    name: 'IndexHome',
    component: asyncComponent({
      loader: () => import('./pages/IndexHome'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/contactafterlogin`,
    name: 'contactafterlogin',
    component: asyncComponent({
      loader: () => import('./pages/ContactAfterLogin'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/contactageverification`,
    name: 'Contactverification',
    component: asyncComponent({
      loader: () => import('./pages/ContactAgeverification'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/home`,
    name: 'Home',
    component: asyncComponent({
      loader: () => import('./pages/Home'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypagemale`,
    name: 'MypageMale',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/indexMale'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypagefemale`,
    name: 'MypageFemale',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/indexFemale'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypage`,
    name: 'MypageFemale',
    component: asyncComponent({
      loader: () => import('./pages/MyPage'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypagemale-job`,
    name: 'MyPageMaleJob',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/indexMaleJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypagefemale-job`,
    name: 'MyPageFemaleJob',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/indexFemaleJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/mypage-job`,
    name: 'MyPageFemaleJob',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/indexJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/chat`,
    name: 'Chat',
    component: asyncComponent({
      loader: () => import('./pages/Chat'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/dangerouslysetInner`,
    name: 'DangerouslysetInner',
    component: asyncComponent({
      loader: () => import('./pages/DangerouslysetInner'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/chat-agent`,
    name: 'Chat',
    component: asyncComponent({
      loader: () => import('./pages/Chat/ChatAgent'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/blog/:id`,
    name: 'OtherBlog',
    component: asyncComponent({
      loader: () => import('./pages/MyBlog/OtherBlog'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/agent-chara-list/:id`,
    name: 'AgentCharaList',
    component: asyncComponent({
      loader: () => import('./pages/AgentCharaList'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/my-blog`,
    name: 'MyBlog',
    component: asyncComponent({
      loader: () => import('./pages/MyBlog'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/profile-edit`,
    name: 'EditProfile',
    component: asyncComponent({
      loader: () => import('./pages/EditProfile'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/help`,
    name: 'Help',
    component: asyncComponent({
      loader: () => import('./pages/Help'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/account`,
    name: 'Account',
    component: asyncComponent({
      loader: () => import('./pages/Account'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/user/:id`,
    name: 'OrtherProfile',
    component: asyncComponent({
      loader: () => import('./pages/OrtherProfile'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/profile-page/:id`,
    name: 'SelfIntroductionPage',
    component: asyncComponent({
      loader: () => import('./pages/OrtherProfile/SelfIntroductionPage'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/myprofile`,
    name: 'MyProfile',
    component: asyncComponent({
      loader: () => import('./pages/MyProfile'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/info-account`,
    name: 'InfoAccount',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/InfoAccount'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/notification_setting`,
    name: 'NotificationSetting',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/NotificationSetting'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/change-phone`,
    name: 'ChangePhone',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/ChangePhone'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/change-email`,
    name: 'ChangeEmail',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/ChangeEmail'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/change-login-method`,
    name: 'ChangeLoginType',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/ChangeLoginType'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/verify-code-change-phone/:phone`,
    name: 'VerifyChangePhone',
    component: asyncComponent({
      loader: () => import('./pages/MyPage/VerifyChangePhone'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-user`,
    name: 'Search',
    component: asyncComponent({
      loader: () => import('./pages/Search'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-result`,
    name: 'SearchResult',
    component: asyncComponent({
      loader: () => import('./pages/Search/SearchResult'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-agent`,
    name: 'SearchAgent',
    component: asyncComponent({
      loader: () => import('./pages/SearchAgent'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-agent-result`,
    name: 'SearchAgentResult',
    component: asyncComponent({
      loader: () => import('./pages/SearchAgent/SearchResult'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/agent-profile/:id`,
    name: 'AgentProfile',
    component: asyncComponent({
      loader: () => import('./pages/AgentProfile'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/login`,
    name: 'Login',
    component: asyncComponent({
      loader: () => import('./pages/Auth/Login'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/register-trial`,
    name: 'RegisterTrial',
    component: asyncComponent({
      loader: () => import('./pages/Auth/RegisterTrial'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-user-trial`,
    name: 'SearchTrial',
    component: asyncComponent({
      loader: () => import('./pages/SearchTrial'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-user-trial-result`,
    name: 'SearchTrialResult',
    component: asyncComponent({
      loader: () => import('./pages/SearchTrial/SearchTrialResult'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-job`,
    name: 'SearchJob',
    component: asyncComponent({
      loader: () => import('./pages/SearchJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-job-result`,
    name: 'SearchJobResult',
    component: asyncComponent({
      loader: () => import('./pages/SearchJob/SearchJobResult'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/point`,
    name: 'BuyPoint',
    component: asyncComponent({
      loader: () => import('./pages/BuyPoint'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/point/:number`,
    name: 'BuyPointDetail',
    component: asyncComponent({
      loader: () => import('./pages/BuyPoint/PointDetail'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/like`,
    name: 'Like',
    component: asyncComponent({
      loader: () => import('./pages/Like'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/plan_user`,
    name: 'BuyPlan',
    component: asyncComponent({
      loader: () => import('./pages/BuyPlan'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/blocklist`,
    name: 'Block',
    component: asyncComponent({
      loader: () => import('./pages/Block'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/info`,
    name: 'Info',
    component: asyncComponent({
      loader: () => import('./pages/Info'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/info/:number`,
    name: 'InfoDetail',
    component: asyncComponent({
      loader: () => import('./pages/Info/InfoDetail'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/favorite`,
    name: 'Favorite',
    component: asyncComponent({
      loader: () => import('./pages/Favorite'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/favorite-job`,
    name: 'FavoriteJob',
    component: asyncComponent({
      loader: () => import('./pages/FavoriteJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/job-entry-list`,
    name: 'JobEntryLList',
    component: asyncComponent({
      loader: () => import('./pages/JobEntryList'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/footprint`,
    name: 'Footprint',
    component: asyncComponent({
      loader: () => import('./pages/Footprint'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: false,
    path: `${process.env.RAZZLE_PUBLIC_URL}/job-list`,
    name: 'JobList',
    component: asyncComponent({
      loader: () => import('./pages/JobList'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/job-lp`,
    name: 'JobLp',
    component: asyncComponent({
      loader: () => import('./pages/JobLp'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/verify_email`,
    name: 'VerifyLogin',
    component: asyncComponent({
      loader: () => import('./pages/Auth/VerifyLogin'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/verify_phone`,
    component: asyncComponent({
      loader: () => import('./pages/Auth/VerifyLogin'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/verify_register`,
    name: 'VerifyRegister',
    component: asyncComponent({
      loader: () => import('./pages/Auth/VerifyRegister'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/verify-email/:id`,
    name: 'VerifyEmail',
    component: asyncComponent({
      loader: () => import('./pages/VerifyEmail'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/pre-register-job-trial/:id`,
    name: 'PreRegisterJobTrial',
    component: asyncComponent({
      loader: () => import('./pages/Auth/PreRegisterJobTrial'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/pre-register-job`,
    name: 'PreRegisterJob',
    component: asyncComponent({
      loader: () => import('./pages/Auth/PreRegisterJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/register-job-confirm`,
    name: 'RegisterJobConfirm',
    component: asyncComponent({
      loader: () => import('./pages/Auth/RegisterJob/RegisterJobConfirm'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/register-job`,
    name: 'RegisterJob',
    component: asyncComponent({
      loader: () => import('./pages/Auth/RegisterJob'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/job-detail/:id`,
    name: 'JobDetail',
    component: asyncComponent({
      loader: () => import('./pages/JobDetail'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/search-job-trial-result`,
    name: 'SearchJobTrialResult',
    component: asyncComponent({
      loader: () => import('./pages/SearchJobTrialResult'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/check-password`,
    name: 'CheckPassword',
    component: asyncComponent({
      loader: () => import('./pages/Auth/CheckPassword'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/register-confirm`,
    name: 'RegisterConfirm',
    component: asyncComponent({
      loader: () => import('./pages/Auth/Register/RegisterConfirm'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/register`,
    name: 'Register',
    component: asyncComponent({
      loader: () => import('./pages/Auth/Register'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/pre-register`,
    name: 'PreRegister',
    component: asyncComponent({
      loader: () => import('./pages/Auth/PreRegister'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    exact: true,
    isPublic: true,
    path: `${process.env.RAZZLE_PUBLIC_URL}/contactnologin`,
    name: 'Contact no login',
    component: asyncComponent({
      loader: () => import('./pages/ContactNoLogin'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
  {
    path: `${process.env.RAZZLE_PUBLIC_URL}${ERROR_404_ROUTE}`,
    name: 'Error404',
    isPublic: true,
    component: asyncComponent({
      loader: () => import('./pages/404/index'), // required
      Placeholder: () => <div>...LOADING...</div>, // this is optional, just returns null by default
    }),
  },
];

export default routes;
